import { reactive } from "vue";
import axios from "axios";
import store from "@/store";
import i18n from "@/locales";

const state = reactive({
  user: null,
  isAuthenticated: false,
});

export function useAuth() {
  const login = async (username, password) => {
    const response = await axios.post("Authentication", {
      UserName: username,
      Password: password,
    });

    if (response.data == "WRONG AUTHORIZE") {
      state.isAuthenticated = false;
      return false;
    }
    if (response.data == "COMPANY IS STOPPED") {
    state.isAuthenticated = false;
    return "company_stopped";
}
    if (response.data == "CLIENT IS STOPPED") {
      state.isAuthenticated = false;
      return "client_stopped";
    } else {
      await store.dispatch("auth/F_TOKEN", response.data);

      const langId = localStorage.getItem("LanguageId");
      const countryId = localStorage.getItem("CountryId");
    
      let resolvedLang;
        //console.log('Nakon logina — langId:', langId, 'countryId:', countryId, 'resolvedLang:', resolvedLang)
      if (countryId === "2") {
        resolvedLang = "en";
      } else if (countryId === "3") {
        resolvedLang = langId === "4" ? "cir-ekavica" : "lat-ekavica";
      } else {
        resolvedLang = langId === "1" ? "sr" : "bs";
      }
      localStorage.setItem("lang", resolvedLang);
      i18n.global.locale.value = resolvedLang;

      state.user = {
        Id: localStorage.getItem("UserId"),
        Name: localStorage.getItem("Name"),
        UserName: localStorage.getItem("UserName"),
        RoleId: localStorage.getItem("RoleId"),
        Email: localStorage.getItem("Email"),
        LanguageId: langId,
        CountryId: localStorage.getItem("CountryId"),
      };

      state.isAuthenticated = true;
      return true;
    }
  };

  const logout = () => {
    localStorage.clear();
    state.user = null;
    state.isAuthenticated = false;
  };

  return {
    state,
    login,
    logout,
  };
}
